<template>
  <div class="mii-table" :class="{'mii-table-1': style === 1, 'mii-table-2': style !== 1}">
    <div class="table-tool" v-if="output_file">
      <a href="javascript:;">
        <i class="iconfont icon-zhankai-copy" @click="scroll_table_2 = !scroll_table_2"></i>
      </a>
      <a href="javascript:;">
        <i class="iconfont icon-daochu" @click="optPutFile"></i>
      </a>
    </div>
    <content-title :title="title"></content-title>
    <table :class="{'table-style-1': table_style === 1 && !one_row, 'table-style-2': table_style !== 1 && !one_row, 'one-row': one_row, 'scroll-table': scroll_table_2}">
      <thead>
        <tr>
          <th v-for="th in ths">{{th.label}}</th>
        </tr>
      </thead>
      <tbody :style="table_style_height">
        <tr v-for="(data, index) in (show_pagination ? (datas || []).slice(start_index, start_index + this.row_num) : (datas || []))" style="overflow: auto;max-height: 20rem;">
          <td v-for="(th, index2) in ths" @dblclick="startEdit(index, th.key, data[th.key], data[ths[0].key])">
            <input v-model="new_value" name="" value="" placeholder="" v-if="index2!==0 && canEdit && index === edit_value.column&&th.key === edit_value.key" v-on:blur="save">
            <div  v-html="data[th.key]" v-else>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="pagination-table" v-if="show_pagination">
      <el-pagination small layout="prev, pager, next" v-on:current-change="pageChange" :page-size="row_num" :total="(datas || []).length">
      </el-pagination>
    </div>
  </div>
</template>

<script>
  import ContentTitle from '../components_bit/ContentTitle'
  import {
    outPutExcelFile
  } from '../cllib'
  export default {
    components: {
      'content-title': ContentTitle
    },
    computed: {
      show_data: {
        get () {
          let data = []
          if (this.show_pagination) {
            data = (this.datas || []).slice(this.start_index, this.start_index + this.row_num)
          } else {
            data = this.datas || []
          }
          return data
        }
      },
      table_style_height: {
        get () {
          if (this.table_height && this.scroll_table) {
            return {
              height: this.table_height + 'rem'
            }
          } else {
            return {}
          }
        }
      }
    },
    data () {
      return {
        scroll_table_2: false,
        new_value: null,
        edit_value: {
          column: -1,
          key: '',
          unit: ''
        },
        style: 0,
        page: 1,
        start_index: 0
      }
    },
    methods: {
      optPutFile () {
        let datas = [{
          data: [],
          sheetName: 'data1'
        }]
        let vm = this
        let row1 = []
        this.ths.forEach(function (thsItem) {
          row1.push(thsItem.label)
        })
        datas[0].data.push(row1)
        this.datas.forEach(function (item) {
          let data = []
          vm.ths.forEach(function (item2) {
            data.push(item[item2.key])
          })
          datas[0].data.push(data)
        })
        outPutExcelFile(datas, (this.oputput_file_name || 'MiiRo') + '.xls')
      },
      pageChange (currentPage) {
        this.start_index = (currentPage - 1) * this.row_num
      },
      startEdit (index, key, value, unit) {
        this.edit_value = {
          column: index,
          key: key,
          unit: unit
        }
        this.new_value = value
      },
      save () {
        this.$store.dispatch('editSourceData', {newData: this.new_value, ...this.edit_value})
        this.edit_value = {
          column: -1,
          key: '',
          unit: ''
        }
      }
    },
    props: ['datas', 'ths', 'title', 'table_style', 'one_row', 'row_num', 'show_pagination', 'canEdit', 'scroll_table', 'table_height', 'output_file', 'oputput_file_name'],
    created () {
      this.style = (this.datas || []).length > 10 ? this.table_style : ((this.datas || []).length % 2 === 0 ? this.table_style : (3 - this.table_style))
      this.scroll_table_2 = this.scroll_table
    }
  }
</script>

<style lang="less">
  .mii-table{
    .icon-jiantou {
      font-weight: 600;
      padding: 0 0.2em;
    }
    .el-pagination button {
      background-color: rgba(0, 0, 0, 0);
    }
    .el-pager li {
      background-color: rgba(0, 0, 0, 0);
    }
    .el-pager li.active {
      background-color: #20a0ff;
    }
  }
</style>

<style scoped lang="less">
  @import '../style/base.less';
  .table-tool {
    position: absolute;
    right: 1rem;
    top: 0.5rem;
    i {
      font-size: 1.3rem;
      margin-left: 1rem;
      color: #fff;
    }
  }
  .scroll-table {
    tbody {
      display:block;
      height: 25rem;
      overflow-y:scroll;
    }
    thead, tbody tr {
      display:table;
      width:100%;
      table-layout:fixed;
    }
  }

  .mii-table-1 {
    background-color: @bak-color-td-2;
  }
  .mii-table-2 {
    background-color: @bak-color-td-1;
  }
  .pagination-table {
    text-align: right;
    margin-right: 0.5em;
  }
  .mii-table {
    position: relative;
    display: flex;
    flex:1;
    flex-direction:column;
    box-shadow: 1px 2px 4px rgba(0, 0, 0, 0.3);
    padding-bottom: @content-border-radius-size;
    border-radius: @content-border-radius-size;
    input {
      width: 6em;
      line-height: 1;
      padding: 0;
      margin: 0;
      font-size: 1em;
    }
    table {
      border-spacing: 0;
      width: 100%;
      th {
        background-color: @bak-color-th;
        font-size: 1.13em;
        line-height: 2;
        color: @font-color-3;
        font-weight: 100;
        text-align: left;
      }
      td {
        text-align: left;
        font-size: 1em;
        line-height: 1.6;
        color: @font-color-3;
      }
      th:first-child {
        padding-left: 2.5em;
      }
      td:first-child {
        padding-left: 2.5em;
      }
    }
    .one-row {
      td {
        line-height: 2.4;
      }
      tr:nth-child(odd){
        background: #fff;
      }
      tr:nth-child(even){
        background: @bak-color-td-1;
      }
    }
    .table-style-2 {
      tr:nth-child(odd){
        background: @bak-color-td-2;
      }
      tr:nth-child(even){
        background: @bak-color-td-1;
      }
    }
    .table-style-1 {
      tr:nth-child(odd){
        background: @bak-color-td-1;
      }
      tr:nth-child(even){
        background: @bak-color-td-2;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// MiiTable.vue?7422543a